import config from '../../../public/harness_config.json';

export default {
  methods: {
    deleteElement(selector) {
      if (document.querySelector(selector)) {
        const widgetWrap = document.querySelector(selector);
        widgetWrap.parentNode.removeChild(widgetWrap);
      }
    },
    attachJsExampleV2() {
      this.deleteElement('.h-widget-wrap');
      this.deleteElement('.test-script-wrap');

      const widgetUrl = `${config.scheme}://widget.${config.url}/harness-widget-v2.js`;

      const self = this;

      (function(url, callback) {
        // Adding the script tag to the head as suggested before
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;

        // Then bind the event to the callback function.
        // There are several events for cross browser compatibility.
        script.onreadystatechange = callback;
        script.onload = callback;

        const scriptWrap = document.createElement('div');
        scriptWrap.classList.add('test-script-wrap');
        scriptWrap.appendChild(script);

        document.body.appendChild(scriptWrap);

      })(widgetUrl, function() {
        window.HarnessWidget.init({charity_id: self.activeCharityId});
      });
    },
  },
  computed: {
    jsTemplateV2: function() {
      if (config.url === 'staging.harnessapp.com') {
        config.scheme = 'http';
      }

      const widgetUrl = `${config.scheme}://widget.${config.url}/harness-widget-v2.js`;
      return '<!-- Harness Code -->\n<script>\n!function(t,e){var a=document.head,n=document.createElement("script");n.type="text/javascript",n.src="' +
        widgetUrl +
        '",n.onreadystatechange=e,n.onload=e,a.appendChild(n)}(0,function(){window.HarnessWidget.init({charity_id:"' +
        this.activeCharityId + '"})});\n<' + '/script>\n<!-- End Harness Code -->';
    },
  },

};
